module.exports = __webpack_public_path__ + "img/position.bf078faf.svg";